import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

const rramosConsultoriaTheme = {
  defaultTheme: 'light',
  themes: {
    light: {
      dark: false,
      colors: {
        primary: '#3E3E3E',
        secondary: '#B3B3B3',
        accent: '#D1C5B2',
        info: '#6A7D8B',
        background: '#F7F7F7',
        success: '#4CAF50',
        error: '#FF5252',
        warning: '#FFC107',
      },
    },
    dark: {
      dark: true,
      colors: {
        primary: '#D1C5B2',
        secondary: '#9BA6B2',
        accent: '#3E3E3E',
        info: '#B3B3B3',
        background: '#121212',
        success: '#4CAF50',
        error: '#FF5252',
        warning: '#FFC107',
      },
    },
  },
}

export default createVuetify({
  theme: rramosConsultoriaTheme,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    VBtn: {
      variant: 'flat',
    },
    VCard: {
      elevation: 2,
    },
  },
  display: {
    mobileBreakpoint: 'sm',
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
})
